import { useEffect, useRef } from "react";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";
const SLOTS = {
  header: process.env.REACT_APP_ADSENSE_SLOT_HEADER || "",
  incontent: process.env.REACT_APP_ADSENSE_SLOT_INCONTENT || "",
  sidebar: process.env.REACT_APP_ADSENSE_SLOT_SIDEBAR || "",
  footer: process.env.REACT_APP_ADSENSE_SLOT_FOOTER || "",
};
const SIZES = {
  header: { minHeight: 90, maxWidth: 970, label: "728×90" },
  incontent: { minHeight: 250, maxWidth: 728, label: "Responsive" },
  sidebar: { minHeight: 250, maxWidth: 300, label: "300×250" },
  footer: { minHeight: 90, maxWidth: 970, label: "Responsive" },
};

// AdSense-ready, CLS-safe ad slot. Renders a labeled reserved container to avoid layout shift.
export const AdSlot = ({ placement = "incontent", className = "" }) => {
  const ref = useRef(null);
  const slot = SLOTS[placement];
  const live = Boolean(CLIENT && slot);
  const size = SIZES[placement] || SIZES.incontent;

  useEffect(() => {
    if (!live) return;
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch { /* adsense not ready */ }
  }, [live]);

  // Auto ads mode (no manual slot configured): render nothing and let Google place ads automatically.
  if (!live) return null;

  return (
    <aside role="complementary" aria-label="Advertisement" className={`w-full my-6 ${className}`} data-testid={`ad-${placement}`}>
      <div className="text-[10px] font-medium uppercase tracking-[0.2em] text-muted-foreground text-center mb-1.5">Advertisement</div>
      <div
        className="mx-auto flex items-center justify-center rounded-xl border border-dashed border-border bg-muted/30 overflow-hidden"
        style={{ minHeight: size.minHeight, maxWidth: size.maxWidth, width: "100%" }}
      >
        <ins
          ref={ref}
          className="adsbygoogle"
          style={{ display: "block", width: "100%" }}
          data-ad-client={CLIENT}
          data-ad-slot={slot}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    </aside>
  );
};

export const AdDisclaimer = () => (
  <p className="text-[11px] leading-relaxed text-muted-foreground text-center max-w-2xl mx-auto mt-2" data-testid="ad-disclaimer">
    Advertisements on this site are served by Google. Google may use cookies to serve ads based on your prior visits and may show personalised ads according to your preferences. You can manage your ad settings via your Google account.
  </p>
);
